export default __webpack_public_path__ + "static/media/the-high-priestess@2x.965addcb.png";